import _ from 'lodash';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import env from '../../../util/env';
import * as DocumentActions from '../../../actions/Document/documentactions';
import * as FourFortyGlDocumentActions from '../../../actions/Document/fourFortyGlDocumentActions';
import * as DuplicateDocumentsActions from '../../../actions/Document/duplicatedocumentsactions';
import {counterOperation} from '../../../util/uiconstants';

const initDocHelper = function(store) {
	//console.log('📃 : DocHelperConfig', env.getDocHelperConfig());
	return new Promise((resolve, reject) => {
		var SignalRDocHubLoaded = function() {
			return new Promise((resolve, reject) => {
				if (!window.jQuery.connection[env.getDocHelperConfig().hubName]) {
					return reject(['0010', 'Connection Failed', labels.documentHelperConnectionIssue]);
				}
				window.jQuery.extend(window.jQuery.connection[env.getDocHelperConfig().hubName].client, {
					uploadComplete: function(message) {
						const storeState = store.getState();

						if (Number(message?.EngagementId) !== Number(storeState?.engagement?.engagementId)) {
							return;
						}

						// Get uploaded file data from the store
						let documentData;
						if (storeState.docHelperDocuments && storeState.docHelperDocuments) {
							documentData = storeState.docHelperDocuments[message.FileName];
						}

						// This happens only after uploading a file after editing it
						if ((!documentData || !documentData.isUserUpload) && message.FileVersion > 1) {
							if (storeState.fourFortyGlDocuments.documents) {
								const fourFortyDocumentData =
									storeState.fourFortyGlDocuments.documents.byId[message.FileId.toUpperCase()];
								const show440GLModal = Utility.isChangeReasonRequired(
									storeState.engagement,
									storeState.quickLink,
									fourFortyDocumentData
								);

								const documentConnectionId = fourFortyDocumentData?.connectionId;
								const currentConnectionId = window.jQuery.connection[env.getDocHelperConfig().hubName].connection.id;

								// Document was uploaded within the current browser tab
								if (documentConnectionId === currentConnectionId) {
									store.dispatch(FourFortyGlDocumentActions.showChangeReasonModal(show440GLModal, message.FileId));
								}
							}
						}
						let taskId = null;
						if (storeState.taskList) {
							taskId = Object.keys(storeState.taskList).length > 0 ? storeState.taskId : null;
						}

						store
							.dispatch(
								DocumentActions.getDocumentById(
									message.EngagementId,
									message.FileId,
									undefined,
									'tasks',
									taskId,
									true,
									{
										IncludeReviewNotes: true,
										IncludeApprovals: true
									}
								)
							)
							.then(() =>
								store.dispatch({
									type: 'DOCUMENT_UPLOAD_COMPLETE',
									meta: {message},
									engagementId: storeState.engagement?.engagementId
								})
							);
					},
					uploadError: function(message, Id) {},
					uploadProgress: function(message) {
						const storeState = store.getState();
						if (Number(message?.EngagementId) !== Number(storeState?.engagement?.engagementId)) {
							return;
						}
						store.dispatch(DuplicateDocumentsActions.updateGLAccountUploadingCount(counterOperation.increment));
						store
							.dispatch({
								type: 'DOCUMENT_UPLOAD_PROGRESS',
								meta: {message},
								engagementId: storeState.engagement?.engagementId
							})
							.finally(() => {
								store.dispatch(DuplicateDocumentsActions.updateGLAccountUploadingCount(counterOperation.decrement));
							});
					},
					addDocumentError: function(message) {},
					addDocumentComplete: function(message) {
						console.log(' ✔✔ AddDocumentComplete : from DocumentHub');
					},
					downloadProgress: function(message) {},
					downloadComplete: function(message) {},
					downloadCanceled: function(message) {}
				});

				// window.jQuery.connection.hub.qs = {
				// 	engagementId: this.props.engagement.engagementId,
				// 	userid: this.props.userPreferences.id,
				// 	firstname: this.props.userPreferences.firstName,
				// 	lastname: this.props.userPreferences.lastName,
				// 	engagementdesc: this.props.engagement.engagementDescription
				// };
				window.jQuery.connection.hub.url = env.getDocHelperConfig().SignalRHubUrl;
				if (!window.jQuery.connection[env.getDocHelperConfig().hubName]) {
					return reject(new Error('jQuery connnection to DocumentHub failed!'));
				}
				if (window.jQuery.connection) {
					//DocumentHubConfig.checkSignalRConnectionState();
					window.jQuery.connection.hub.logging = true;
					window.jQuery.connection.hub
						.start()
						.done(() => {
							return resolve();
						})
						.fail((e) => {
							return reject(e);
						});
				} else {
					return reject(new Error('jQuery connnection not available!'));
				}
			});
		};

		var updateState = function(change) {
			console.log(window.jQuery.signalR.connectionState);
			var states = window.jQuery.signalR.connectionState;
			// this.connected =
			// 	change.newState === states.connected ||
			// 	change.newState === states.reconnecting;
		};
		var disconnect = function() {
			console.log(window.jQuery.signalR.connectionState);
			console.log('SignalR Hub Disconnected');
			if (window.jQuery.connection.hub.lastError) {
				console.log(`Disconnected Reason: ${window.jQuery.connection.hub?.lastError?.message}`);
			}
			//this.connected = false;
			//TODO: network error should be a promise reject to be handled
			//networkError();

			_.delay(function() {
				window.jQuery.connection.hub.start();
			}, 10 * 1000);
		};
		// Updates View status when connection is lost
		var networkError = function() {
			console.log(window.jQuery.signalR.connectionState);
			console.log('SignalR Slow Connnection - Reconnecting');
			// store.dispatch({
			// 	type: 'DOCHELPER_ERROR',
			// 	error: ['', '', 'SignalR Network Error']
			// });
		};
		var monitor = function() {
			console.log('SignalR Hub started');
			//this.connected = true;
			// Display error if connection is too slow
			window.jQuery.connection.hub
				// Update connectivity status
				.stateChanged(updateState)
				// Initialize again if TrayApp is closed
				.disconnected(disconnect)
				.connectionSlow(networkError);
			return resolve();
		};

		sessionStorage.removeItem('docHubDownloadCallbacksRegistered');
		sessionStorage.removeItem('docHubUploadCallbacksRegistered');
		window.jQuery
			.ajax({
				url: env.getDocHelperConfig().SignalRHubUrl,
				dataType: 'script',
				async: true
			})
			.done(() => {
				SignalRDocHubLoaded()
					.then(monitor)
					.catch((e) => {
						store.dispatch({
							type: 'DOCHELPER_ERROR',
							error: e
						});
						return reject(e);
					});
			});
	});
};

export default initDocHelper;
